// extracted by mini-css-extract-plugin
export var icon = "_6n-1";
export var subtext = "_6n-0";